import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'

import { useAppStore } from '@/popup/store/AppStore'
import { useUIStore } from '@/popup/store/UIStore'
import EmptyCube from '@/popup/components/shared/EmptyCube.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyTab',
  setup(__props) {

const appStore = useAppStore()
const uiStore = useUIStore()

const isPortalEmpty = computed(() => {
  const currentTab = uiStore.currentTab
  const hasAuthenticatedApps = appStore.authenticatedApps.length > 0
  const hasActivities = appStore.transactions.length > 0

  return (
    (currentTab === 'AUTHENTICATED' && !hasAuthenticatedApps) ||
    (currentTab === 'ACTIVITY' && !hasActivities)
  )
})

return (_ctx: any,_cache: any) => {
  return (isPortalEmpty.value)
    ? (_openBlock(), _createBlock(EmptyCube, {
        key: 0,
        class: "tab-content",
        "data-testid": "empty-state",
        title: _ctx.$t('profile.empty.title'),
        width: 100
      }, null, 8 /* PROPS */, ["title"]))
    : _createCommentVNode("v-if", true)
}
}

})